import { render, staticRenderFns } from "./Investment.vue?vue&type=template&id=448d84b8&scoped=true&"
import script from "./Investment.vue?vue&type=script&lang=js&"
export * from "./Investment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d84b8",
  null
  
)

export default component.exports